import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ViewVoteIconsConstants } from '../../../../../../shared/constants/view-vote-icons-constants';
import { ViewVotesPopoverComponent } from '../../../../shared/components/view-votes-popover/view-votes-popover.component';
import { VotesDocumentsPopoverComponent } from '../../../../shared/components/votes-documents-popover/votes-documents-popover.component';
import { IIecBallotVote, IecVoteId, iecVoteOption } from '../../../../shared/models/iec/iec-ballot-vote';
import { IVotePopoverItem } from '../../../../shared/models/vote-popover-item';
import { BallotUri } from '../../../../shared/services/ballot-document.service';
import { IecBallotService } from '../../../../shared/services/iec-ballot.service';

@Component({
    selector: 'app-iec-vote-column',
    templateUrl: './iec-vote-column.component.html',
    styleUrl: './iec-vote-column.component.scss',
    standalone: false
})
export class IecVoteColumnComponent implements OnChanges, OnDestroy {

  @ViewChild('commentPopover') commentPopover!: ViewVotesPopoverComponent;
  @ViewChild('historyPopover') historyPopover!: ViewVotesPopoverComponent;
  @Input() vote: IIecBallotVote | null = null;
  @Input() isUserPmOrAboveOrHoSD: boolean = false;
  @Input() isUserCM: boolean = false;
  @Input() loginUserEmail: string = '';

  subscriptions: Subscription = new Subscription();
  voteCommentPopoverItems: IVotePopoverItem[] = [];
  voteHistoryPopoverItems: IVotePopoverItem[] = [];

  public readonly ViewVoteIconsConstants = ViewVoteIconsConstants;

  iconName: string = '';
  colorClass: string = '';
  hasComment: boolean = false;
  hasDocument: boolean = false;
  hasHistories: boolean = false;
  showingDocumentIcon: boolean = false;

  BallotType = BallotUri.IEC;

  constructor(private _iecBallotService: IecBallotService) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['vote']) {
      this.vote = changes['vote'].currentValue;
      if(this.vote){
        const voteId = this.vote?.iecVoteOptionName;
        const isEligible = this.vote?.isEligible;
        if(isEligible){
          this.checkVoteType(voteId as IecVoteId);
          this.checkComment(this.vote);
          this.checkDocument(this.vote);
          this.checkHistories(this.vote);
          this.checkUserVote(this.vote);
        }
      }
    }
  }

  checkVoteType(voteId: IecVoteId): void {
    this.iconName = iecVoteOption[voteId]?.icon;
    this.colorClass = iecVoteOption[voteId]?.color;

  }

  checkComment(vote:IIecBallotVote): void{
    this.hasComment = vote?.hasCommented;
  }

  checkDocument(vote:IIecBallotVote): void{
    this.hasDocument = vote.hasAuthDocument;
  }

  checkHistories(vote:IIecBallotVote): void{
    if (vote.submitted && vote.submitted.toString().trim() !== '') {
      this.hasHistories = true;
    } else {
      this.hasHistories = false;
    }
  }

  checkUserVote(vote:IIecBallotVote) {
    if(this.isUserPmOrAboveOrHoSD) {
      this.showingDocumentIcon = this.hasDocument;
    } else if(this.isUserCM) {
      const voterEmail = vote.email;
      if (voterEmail?.trim() && this.loginUserEmail?.trim()) {
        this.showingDocumentIcon = (voterEmail.toLowerCase() == this.loginUserEmail?.toLowerCase()) && this.hasDocument;
      } else {
        this.showingDocumentIcon = false
      }
    }
  }


  openPopover(popover: ViewVotesPopoverComponent) {
    this.getVotePopoverItems();
    popover.openPopover();
  }

  openVoteDocumentsPopover(popover: VotesDocumentsPopoverComponent) {
    popover.openPopover();
  }


  getVotePopoverItems(): void {
    this.voteCommentPopoverItems = [];
    this.voteHistoryPopoverItems = [];
    if ((this.hasComment || this.hasHistories) && this.vote && this.vote.iecBallotId && this.vote.id){
      // fetch IEC ballot vote history
      this.subscriptions.add(this._iecBallotService.getIECBallotVoteHistory(this.vote.iecBallotId, this.vote.id).subscribe({
        next: (response) => {
          if (response && response.success) {
            console.log('Vote history fetched successfully', response.content);
            this.voteCommentPopoverItems = response.content
              .filter((comment) => iecVoteOption[comment.voteOptionName] !== undefined && typeof comment.remarks === 'string' &&comment.remarks?.trim() !== '')
              .map((comment) => {

                const voteResult = iecVoteOption[comment.voteOptionName];
                const popoverItem : IVotePopoverItem = {
                  voteOption: voteResult,
                  additionalComments: comment.remarks,
                  voteSubmittedDate: comment.submitted
                };

                return popoverItem;
            });

            this.voteHistoryPopoverItems = response.content
              .filter((comment) => iecVoteOption[comment.voteOptionName] !== undefined)
              .map((comment) => {
                const voteResult = iecVoteOption[comment.voteOptionName];
                const popoverItem : IVotePopoverItem = {
                  voteOption: voteResult,
                  voteSubmittedDate: comment.submitted,
                  additionalComments: null
                };

                return popoverItem;
            });

          } else {
            console.error('Error fetching vote history.', response.message);
          }
        },
        error: (error) => {
          console.error('Error fetching vote history.', error);
        }
      }));
    }
  }
}

